class Data {

    constructor(data) {

        // Url and the prefix
        // For fetching data
        this.url = data.url;
        this.prefix = data.prefix;
        this.chat = data.chat ? data.chat : false;
        this.filters = {};
        this.extra = data.extra;


        // Default sort

        this.sort = {
            field: 'id',
            direction: 'desc',
        };

        // Size
        this.filters.size = 10;

        // Search

        this.filters.search = "";

        // Loading state

        this.loading = false;


        // Start Default Pages number

        this.page = 1;

        // Default Content

        this.content = {
            current_page: 1,
            last_page: 1,
            data: [],
            total: 0,
            to: 0
        };

        for (const key in this.extra)
        {
            this.filters[key] = this.extra[key];
        }
    }

    // Building the url for sending on the ajax requests

    build(chatOverride = false) {
        // Start url

        let number = chatOverride ? 1 : this.page;
        let url = `${window.location.origin}${this.url}?page=${number}`;

        for (const property in this.filters) {
            if (this.filters[property] !== undefined) {
                url += `&${property}=${this.filters[property]}`;
            }

        }

        // Adding Sort , Search , Page number  to the url
        return url + `&sort=${this.sort.field},${this.sort.direction}`;
    }

    fetchPage(page){
        this.page = page;
        return this.load(false);
    }

    fetchNext(){
        this.page++;
        return this.load(false);
    }

    fetchPrevious(){
        this.page--;
        return this.load(false);
    }

    fetch() {
        return this.load(false);
    }

    append() {
        return this.load(true);
    }

    appendChat() {
        return this.load(true, false, true);
    }

    // Send Ajax Requests to the server and the assign values
    load(append, chatOverride = true, isNewChat = false) {
        return new Promise((resolve, reject) => {

            // Open the loader
            this.openLoader();

            // Assign the page number based on request
            this.page = append ? this.page + 1 : 1;

            window.axios.get(this.build(isNewChat)).then((response) => {

                // Append Content

                if (append) {
                    // Push items to content
                    if (this.chat && chatOverride) {
                        response.data.body[this.prefix].data.forEach((value) => {
                            this.content.data.unshift(value);
                        });

                    } else {

                        if (isNewChat) {
                            response.data.body[this.prefix].data.reverse().forEach((value) => {
                                this.content.data.push(value);
                            });

                        } else {

                            response.data.body[this.prefix].data.forEach((value) => {
                                this.content.data.push(value);
                            });

                        }
                    }

                    // Update all content data remaining
                    if (!isNewChat) {
                        this.content.to = response.data.body[this.prefix].to;
                        this.content.total = response.data.body[this.prefix].total;
                    }

                    resolve();

                    return;
                }

                // Replace all content data
                if (this.chat) {
                    this.content = {
                        last_page: response.data.body[this.prefix].last_page,
                        current_page: response.data.body[this.prefix].current_page,
                        data: response.data.body[this.prefix].data.reverse(),
                        total: response.data.body[this.prefix].total,
                        to: response.data.body[this.prefix].to
                    };
                } else {
                    this.content = response.data.body[this.prefix];
                }

                resolve();

            }).catch((error) => {

                reject();

            }).finally(() => {
                this.closeLoader();
            });
        });
    }

    // Sets the loader to loading state
    openLoader() {
        this.loading = true;
    }

    // Sets the loader to closed state
    closeLoader() {
        this.loading = false;
    }
}

export default Data;
